import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createMemberRecycle() {
  yield takeEvery(actions.CREATE_MEMBER_RECYCLE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/memberRecycle`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_RECYCLE_ENDED });
    }
  });
}

function* searchMemberRecycles() {
  yield takeEvery(actions.SEARCH_MEMBER_RECYCLES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberRecycle?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_RECYCLES_ENDED });
    }
  });
}

function* updateMemberRecycle() {
  yield takeEvery(actions.UPDATE_MEMBER_RECYCLE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/memberRecycle`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_RECYCLE_ENDED });
    }
  });
}

function* deleteMemberRecycles() {
  yield takeEvery(actions.DELETE_MEMBER_RECYCLES, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/memberRecycle`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_RECYCLES_ENDED });
    }
  });
}

function* triggerMemberRecycle() {
  yield takeEvery(actions.TRIGGER_MEMBER_RECYCLE, function* (action) {
    const { id, onSuccess, isRetry } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${API_HOST}/api/memberRecycle/${id}/trigger`,
        { isRetry },
        { timeout: 900000 }, // 15 minute
      );
      yield delay(3000);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.TRIGGER_MEMBER_RECYCLE_ENDED });
    }
  });
}

function* searchMemberRecycleMemberRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_RECYCLE_MEMBER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberRecycle/record/member?${parameters.toString()}`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_RECYCLE_MEMBER_RECORDS_ENDED });
    }
  });
}

function* searchMemberRecycleTriggerRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_RECYCLE_TRIGGER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberRecycle/record/trigger?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_RECYCLE_TRIGGER_RECORDS_ENDED });
    }
  });
}

function* getMemberRecycleTriggerRecordStatistics() {
  yield takeEvery(actions.GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS, function* (action) {
    const { memberRecycleId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberRecycle/${memberRecycleId}/record/statistics`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMemberRecycle),
    fork(searchMemberRecycles),
    fork(updateMemberRecycle),
    fork(deleteMemberRecycles),
    fork(triggerMemberRecycle),
    fork(searchMemberRecycleMemberRecords),
    fork(searchMemberRecycleTriggerRecords),
    fork(getMemberRecycleTriggerRecordStatistics),
  ]);
}
